import React from "react";
import Konva from "konva";
import { Group, Path } from "react-konva";
import { IMondayTaskController } from "../../controller";
import { MondayItemData } from "shared/integrations/monday-types";
import Hoverable from "frontend/ui-components/konva-helpers/hoverable";
import useObservableController from "elements/hooks/use-observable-controller";
import tracking from "frontend/tracking";

const SIZE = 16;
const ICON_WIDTH = 8;
const ICON_HEIGHT = 5;

interface ExpandUpdateButtonProps extends Konva.NodeConfig {
  controller: IMondayTaskController;
  update: MondayItemData["updates"][0];
}

export const ExpandUpdateButton = React.memo(({ controller, update, ...restProps }: ExpandUpdateButtonProps) => {
  useObservableController(controller, ["update-expansion-changed"]);
  const isExpanded = controller.element.expandedUpdateId === update.id;

  function onExpand() {
    tracking.trackAnalyticsEvent("monday_task_update_expanded", {
      action: isExpanded ? "collapse" : "expand",
    });
    controller.toggleUpdateExpansion(update.id);
  }

  const chevronDown = (
    <>
      <Path
        x={SIZE / 2 - ICON_WIDTH / 2}
        y={SIZE / 2 - ICON_HEIGHT / 2}
        stroke="#1E1E1E"
        strokeWidth={1.2}
        lineCap="round"
        data="M7 1L4 4"
        listening={false}
      />
      <Path
        x={SIZE / 2 - ICON_WIDTH / 2}
        y={SIZE / 2 - ICON_HEIGHT / 2}
        stroke="#1E1E1E"
        strokeWidth={1.2}
        lineCap="round"
        data="M1 1L4 4"
        listening={false}
      />
    </>
  );

  const chevronUp = (
    <>
      <Path
        x={SIZE / 2 - ICON_WIDTH / 2}
        y={SIZE / 2 - ICON_HEIGHT / 2}
        stroke="#1E1E1E"
        strokeWidth={1.2}
        lineCap="round"
        data="M1.00006 4L4.00006 1"
        listening={false}
      />
      <Path
        x={SIZE / 2 - ICON_WIDTH / 2}
        y={SIZE / 2 - ICON_HEIGHT / 2}
        stroke="#1E1E1E"
        strokeWidth={1.2}
        lineCap="round"
        data="M7.00006 4L4.00006 1"
        listening={false}
      />
    </>
  );

  return (
    <Group
      {...restProps}
      width={SIZE}
      height={SIZE}
      onClick={(e) => {
        e.evt.stopPropagation();
        e.evt.preventDefault();
        onExpand();
      }}
    >
      <Hoverable
        cornerRadius={6}
        width={SIZE}
        height={SIZE}
        opacity={0.3}
        fill="transparent"
        hoverFill="#F6F7FB"
        cursor="pointer"
        listening
      />
      {isExpanded ? chevronUp : chevronDown}
    </Group>
  );
});

ExpandUpdateButton.displayName = "ExpandUpdateButton";
